export const BAD_REQUEST = 400;
export const OK = 200;
export const NOT_FOUND = 404;
export const FORBIDDEN = 403;
export const UNAUTHORIZED = 401;
